import { defineStore } from 'pinia'
import moment from 'moment'
import repositoryFactory from '@/factories/repository-factory'
import HistoryRepository from '@/repositories/history-repository'
import { HistoryItem } from '@/models/History'
import { rangeToISO } from '@/lib/formatter'

const storeKey = 'water_detail'

export const useWaterDetailStore = defineStore(storeKey, {
  state: () => ({
    history: [] as HistoryItem[],
  }),

  getters: {
    current: state => {
      return state.history[0]?.waterLevel
    },

    currentTime: state => {
      return state.history[0]?.time
    },

    diff: state => {
      const history = state.history

      if (!history[0] && !history[1]) {
        return 0
      }

      return state.history[0].waterLevel - state.history[1].waterLevel
    },
  },

  actions: {
    async fetch(stationId: string, resolution: string, date: Date) {
      const endTime = moment(date).format('YYYY-MM-DD HH:mm:ss') as string
      const startTime = moment(date).add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
      const params = {
        stationId,
        range: {
          ...rangeToISO({
            startTime,
            endTime,
          } as Range),
          type: resolution === 'ten_min' ? 'hour' : 'day',
        },
        target: ['water_level'],
      }

      const repository = (await repositoryFactory.create()).get('history') as HistoryRepository
      const response = await repository.get(params)

      this.history = [...response.items.sort((a, b) => (moment(a.time).unix() > moment(b.time).unix() ? -1 : 1))]
    },
  },
})
